import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import {provideAnimations} from '@angular/platform-browser/animations';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {provideRouter} from '@angular/router';

import {provideServiceWorker} from '@angular/service-worker';
import {provideCharts, withDefaultRegisterables} from 'ng2-charts';
import {NgxMasonryModule} from 'ngx-masonry';

import {providePrimeNG} from 'primeng/config';
import {PrimePreset} from './primeng.preset';

import {appRoutes} from './app.routes';
import {RouteHistoryService} from '@selpia/data-batch/history-access';
import {errorHandlerInterceptor, provideGlobalErrorHandler} from '@selpia/shared/error-handler';

export const appConfig: ApplicationConfig = {
  providers: [
    provideGlobalErrorHandler(!S2WX_FE_DEBUG ? {
      consoleLevels: [],
      appInsightsLevels: ['error', 'warning'],
    } : undefined),
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(appRoutes),
    provideHttpClient(
      withInterceptors([errorHandlerInterceptor]),
    ),
    provideAnimations(),
    provideCharts(withDefaultRegisterables()),
    provideServiceWorker('ngsw-worker.js', {
      //enabled: !isDevMode(),
      enabled: true,
      registrationStrategy: 'registerWhenStable:30000',
    }),
    importProvidersFrom(NgxMasonryModule),
    providePrimeNG({
      theme: {
        preset: PrimePreset,
      },
    }),
    provideAppInitializer(() => {
      inject(RouteHistoryService);
    }),
  ],
};
